export default class FVendor {
  constructor(
      id = 0,
      fdivisionBean = 0,

      vcode = '',
      vname = '',
      avatarImage = '',

      statusActive = true,
      branch = false,
      childOf = 0,

      address1 = '',
      address2 = '',
      district1 = '',
      city1 = '',
      state1 = '',

      phone = '',            // ⛑️ jangan null
      countryCode = 62,

      zipCode = '',
      email = '',

      joinDate = new Date(),
      lastTrans = new Date(),

      noRekening = '',
      currency = 'IDR',

      disc2Margin = 0,
      disc1PlusMargin = 0,

      pkp = true,
      namaPrshFakturPajak = '',
      namaPengusahaKenaPajak = '',
      npwp = '',
      tanggalPengukuhanPkp = new Date(),

      top = 0,
      wsport = '',

      disc1RegManual = false,
      discPlusRegManual = false,

      created = new Date(),
      modified = new Date(),
      modifiedBy = '',

      sourceId = 0
  ) {
    this.id = id;
    this.fdivisionBean = fdivisionBean;
    this.vcode = vcode;
    this.vname = vname;
    this.avatarImage = avatarImage;
    this.statusActive = statusActive;
    this.branch = branch;
    this.childOf = childOf;
    this.address1 = address1;
    this.address2 = address2;
    this.district1 = district1;
    this.city1 = city1;
    this.state1 = state1;
    this.phone = phone;
    this.countryCode = countryCode;
    this.zipCode = zipCode;
    this.email = email;
    this.joinDate = joinDate;
    this.lastTrans = lastTrans;
    this.noRekening = noRekening;
    this.currency = currency;
    this.disc2Margin = disc2Margin;
    this.disc1PlusMargin = disc1PlusMargin;
    this.pkp = pkp;
    this.namaPrshFakturPajak = namaPrshFakturPajak;
    this.namaPengusahaKenaPajak = namaPengusahaKenaPajak;
    this.npwp = npwp;
    this.tanggalPengukuhanPkp = tanggalPengukuhanPkp;
    this.top = top;
    this.wsport = wsport;
    this.disc1RegManual = disc1RegManual;
    this.discPlusRegManual = discPlusRegManual;
    this.created = created;
    this.modified = modified;
    this.modifiedBy = modifiedBy;
    this.sourceId = sourceId;
  }
}
